import React from "react";

import { EditorContent } from "@tiptap/react";
import { useSelector } from "react-redux";
import { Skeleton } from "@mui/material";
import styles from "./RichtextEditor.module.css";
import EditorActions from "./EditorActions";
import { NoteCreationPanel } from "../../..";

const RichTextEditor = ({ editor, editorState, forceNoteCreation, onCancelForceNoteCreation, onSetNoteStatus }) => {
	const noteId = useSelector(({ note }) => note.selectedNote?.id);
	const isLoading = useSelector(({ note }) => note.isLoading);
	const handleRenderBody = () => {
		if (isLoading && !forceNoteCreation) {
			return <Skeleton animation="wave" className={styles.skeleton} variant="rectangular" />;
		}
		if (noteId && !forceNoteCreation) {
			return (
				<div className={styles.editorWrapper}>
					<EditorContent className={styles.textEditor} editor={editor} />
				</div>
			);
		}
		return (
			<NoteCreationPanel
				forceNoteCreation={forceNoteCreation}
				onCancelForceNoteCreation={onCancelForceNoteCreation}
				onSetNoteStatus={onSetNoteStatus}
			/>
		);
	};
	return (
		<>
			{noteId && !forceNoteCreation && <EditorActions editor={editor} editorState={editorState} />}
			<div className={styles.container}>{handleRenderBody()}</div>
		</>
	);
};
export default RichTextEditor;
